import _defineProperty from "/Users/matt/dev/github.com/industriousapps/excelkits-client/node_modules/.pnpm/next@13.5.7_@babel+core@7.25.2_react-dom@18.3.1_react@18.3.1__react@18.3.1_sass@1.79.3/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import clsx from 'clsx';
import React, { useMemo } from 'react';
import { getHostname } from '@/common/utils/strings';
import styles from './styles.module.scss';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

var InstagramIcon = function InstagramIcon(props) {
  return /*#__PURE__*/_jsx("svg", _objectSpread(_objectSpread({}, props), {}, {
    children: /*#__PURE__*/_jsx("g", {
      stroke: "none",
      strokeWidth: "1",
      fill: "none",
      fillRule: "evenodd",
      children: /*#__PURE__*/_jsx("g", {
        transform: "translate(-72.000000, -647.000000)",
        fill: "#161616",
        fillRule: "nonzero",
        children: /*#__PURE__*/_jsx("g", {
          transform: "translate(24.000000, 647.000000)",
          children: /*#__PURE__*/_jsx("path", {
            d: "M58,0 C55.2833333,0 54.9441667,0.0125 53.8775,0.06 C52.8125,0.11 52.0875,0.2775 51.45,0.525 C50.7925,0.78 50.2341667,1.1225 49.6783333,1.67833333 C49.1225,2.23416667 48.7791667,2.79166667 48.525,3.45 C48.2775,4.0875 48.1091667,4.8125 48.06,5.8775 C48.01,6.94416667 48,7.28333333 48,10 C48,12.7166667 48.0125,13.0558333 48.06,14.1225 C48.11,15.1866667 48.2775,15.9125 48.525,16.55 C48.78,17.2066667 49.1225,17.7658333 49.6783333,18.3216667 C50.2341667,18.8766667 50.7916667,19.2208333 51.45,19.475 C52.0883333,19.7216667 52.8133333,19.8908333 53.8775,19.94 C54.9441667,19.99 55.2833333,20 58,20 C60.7166667,20 61.0558333,19.9875 62.1225,19.94 C63.1866667,19.89 63.9125,19.7216667 64.55,19.475 C65.2066667,19.22 65.7658333,18.8766667 66.3216667,18.3216667 C66.8766667,17.7658333 67.2208333,17.2091667 67.475,16.55 C67.7216667,15.9125 67.8908333,15.1866667 67.94,14.1225 C67.99,13.0558333 68,12.7166667 68,10 C68,7.28333333 67.9875,6.94416667 67.94,5.8775 C67.89,4.81333333 67.7216667,4.08666667 67.475,3.45 C67.22,2.7925 66.8766667,2.23416667 66.3216667,1.67833333 C65.7658333,1.1225 65.2091667,0.779166667 64.55,0.525 C63.9125,0.2775 63.1866667,0.109166667 62.1225,0.06 C61.0558333,0.01 60.7166667,0 58,0 Z M58,1.8 C60.6691667,1.8 60.9875,1.81333333 62.0416667,1.85916667 C63.0166667,1.905 63.5458333,2.06666667 63.8975,2.205 C64.3658333,2.38583333 64.6975,2.6025 65.0491667,2.95166667 C65.3983333,3.30166667 65.615,3.63416667 65.7958333,4.1025 C65.9325,4.45416667 66.0958333,4.98333333 66.14,5.95833333 C66.1875,7.01333333 66.1983333,7.33 66.1983333,10 C66.1983333,12.67 66.1858333,12.9875 66.1366667,14.0416667 C66.0858333,15.0166667 65.9233333,15.5458333 65.7858333,15.8975 C65.5991667,16.3658333 65.3866667,16.6975 65.0366667,17.0491667 C64.6875,17.3983333 64.35,17.615 63.8866667,17.7958333 C63.5366667,17.9325 62.9991667,18.0958333 62.0241667,18.14 C60.9625,18.1875 60.65,18.1983333 57.975,18.1983333 C55.2991667,18.1983333 54.9866667,18.1858333 53.9258333,18.1366667 C52.95,18.0858333 52.4125,17.9233333 52.0625,17.7858333 C51.5883333,17.5991667 51.2625,17.3866667 50.9133333,17.0366667 C50.5625,16.6875 50.3383333,16.35 50.1633333,15.8866667 C50.0258333,15.5366667 49.8641667,14.9991667 49.8133333,14.0241667 C49.7758333,12.9741667 49.7625,12.65 49.7625,9.9875 C49.7625,7.32416667 49.7758333,6.99916667 49.8133333,5.93666667 C49.8641667,4.96166667 50.0258333,4.425 50.1633333,4.075 C50.3383333,3.6 50.5625,3.275 50.9133333,2.92416667 C51.2625,2.575 51.5883333,2.35 52.0625,2.17583333 C52.4125,2.0375 52.9383333,1.875 53.9133333,1.825 C54.9758333,1.7875 55.2883333,1.775 57.9625,1.775 L58,1.8 L58,1.8 Z M58,4.865 C55.1625,4.865 52.865,7.165 52.865,10 C52.865,12.8375 55.165,15.135 58,15.135 C60.8375,15.135 63.135,12.835 63.135,10 C63.135,7.1625 60.835,4.865 58,4.865 Z M58,13.3333333 C56.1583333,13.3333333 54.6666667,11.8416667 54.6666667,10 C54.6666667,8.15833333 56.1583333,6.66666667 58,6.66666667 C59.8416667,6.66666667 61.3333333,8.15833333 61.3333333,10 C61.3333333,11.8416667 59.8416667,13.3333333 58,13.3333333 Z M64.5383333,4.6625 C64.5383333,5.325 64,5.8625 63.3383333,5.8625 C62.6758333,5.8625 62.1383333,5.32416667 62.1383333,4.6625 C62.1383333,4.00083333 62.6766667,3.46333237 63.3383333,3.46333237 C63.9991667,3.4625 64.5383333,4.00083333 64.5383333,4.6625 Z"
          })
        })
      })
    })
  }));
};

InstagramIcon.defaultProps = {
  width: "20px",
  height: "20px",
  viewBox: "0 0 20 20",
  version: "1.1",
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink"
};

var XIcon = function XIcon(props) {
  return /*#__PURE__*/_jsxs("svg", _objectSpread(_objectSpread({}, props), {}, {
    children: [/*#__PURE__*/_jsx("path", {
      d: "M11 20.5C16.5228 20.5 21 16.0228 21 10.5C21 4.97715 16.5228 0.5 11 0.5C5.47715 0.5 1 4.97715 1 10.5C1 16.0228 5.47715 20.5 11 20.5Z",
      fill: "black",
      stroke: "white",
      strokeMiterlimit: "10"
    }), /*#__PURE__*/_jsx("path", {
      d: "M4.84 4.7063L9.61988 11.0973L4.80988 16.2936H5.8925L10.1037 11.7441L13.5062 16.2936H17.1902L12.1412 9.5431L16.6184 4.7063H15.5358L11.6576 8.89615L8.52396 4.7063H4.84ZM6.43205 5.50367H8.12444L15.5979 15.4962H13.9055L6.43205 5.50367Z",
      fill: "white"
    })]
  }));
};

XIcon.defaultProps = {
  width: "22",
  height: "21",
  viewBox: "0 0 22 21",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};

var LinkedInIcon = function LinkedInIcon(props) {
  return /*#__PURE__*/_jsx("svg", _objectSpread(_objectSpread({}, props), {}, {
    children: /*#__PURE__*/_jsx("g", {
      stroke: "none",
      strokeWidth: "1",
      fill: "none",
      fillRule: "evenodd",
      children: /*#__PURE__*/_jsx("g", {
        transform: "translate(-116.000000, -647.000000)",
        fill: "#000000",
        fillRule: "nonzero",
        children: /*#__PURE__*/_jsx("g", {
          transform: "translate(24.000000, 647.000000)",
          children: /*#__PURE__*/_jsx("path", {
            d: "M109.039167,17.0433333 L106.0775,17.0433333 L106.0775,12.4025 C106.0775,11.2958333 106.055,9.87166667 104.534167,9.87166667 C102.99,9.87166667 102.754167,11.0758333 102.754167,12.3208333 L102.754167,17.0433333 L99.7925,17.0433333 L99.7925,7.5 L102.6375,7.5 L102.6375,8.80083333 L102.675833,8.80083333 C103.073333,8.05083333 104.04,7.25916667 105.484167,7.25916667 C108.485,7.25916667 109.04,9.23416667 109.04,11.805 L109.04,17.0433333 L109.039167,17.0433333 Z M96.4475,6.19416667 C95.4941667,6.19416667 94.7283333,5.4225 94.7283333,4.47333333 C94.7283333,3.525 95.495,2.75416667 96.4475,2.75416667 C97.3975,2.75416667 98.1675,3.525 98.1675,4.47333333 C98.1675,5.4225 97.3966667,6.19416667 96.4475,6.19416667 Z M97.9325,17.0433333 L94.9625,17.0433333 L94.9625,7.5 L97.9325,7.5 L97.9325,17.0433333 Z M110.520833,0 L93.4758333,0 C92.66,0 92,0.645 92,1.44083333 L92,18.5591667 C92,19.3558333 92.66,20 93.4758333,20 L110.518333,20 C111.333333,20 112,19.3558333 112,18.5591667 L112,1.44083333 C112,0.645 111.333333,0 110.518333,0 L110.520833,0 Z"
          })
        })
      })
    })
  }));
};

LinkedInIcon.defaultProps = {
  width: "20px",
  height: "20px",
  viewBox: "0 0 20 20",
  version: "1.1",
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink"
};

var ThreadsIcon = function ThreadsIcon(props) {
  return /*#__PURE__*/_jsx("svg", _objectSpread(_objectSpread({}, props), {}, {
    children: /*#__PURE__*/_jsx("path", {
      className: "x19hqcy",
      d: "M141.537 88.9883C140.71 88.5919 139.87 88.2104 139.019 87.8451C137.537 60.5382 122.616 44.905 97.5619 44.745C97.4484 44.7443 97.3355 44.7443 97.222 44.7443C82.2364 44.7443 69.7731 51.1409 62.102 62.7807L75.881 72.2328C81.6116 63.5383 90.6052 61.6848 97.2286 61.6848C97.3051 61.6848 97.3819 61.6848 97.4576 61.6855C105.707 61.7381 111.932 64.1366 115.961 68.814C118.893 72.2193 120.854 76.925 121.825 82.8638C114.511 81.6207 106.601 81.2385 98.145 81.7233C74.3247 83.0954 59.0111 96.9879 60.0396 116.292C60.5615 126.084 65.4397 134.508 73.775 140.011C80.8224 144.663 89.899 146.938 99.3323 146.423C111.79 145.74 121.563 140.987 128.381 132.296C133.559 125.696 136.834 117.143 138.28 106.366C144.217 109.949 148.617 114.664 151.047 120.332C155.179 129.967 155.42 145.8 142.501 158.708C131.182 170.016 117.576 174.908 97.0135 175.059C74.2042 174.89 56.9538 167.575 45.7381 153.317C35.2355 139.966 29.8077 120.682 29.6052 96C29.8077 71.3178 35.2355 52.0336 45.7381 38.6827C56.9538 24.4249 74.2039 17.11 97.0132 16.9405C119.988 17.1113 137.539 24.4614 149.184 38.788C154.894 45.8136 159.199 54.6488 162.037 64.9503L178.184 60.6422C174.744 47.9622 169.331 37.0357 161.965 27.974C147.036 9.60668 125.202 0.195148 97.0695 0H96.9569C68.8816 0.19447 47.2921 9.6418 32.7883 28.0793C19.8819 44.4864 13.2244 67.3157 13.0007 95.9325L13 96L13.0007 96.0675C13.2244 124.684 19.8819 147.514 32.7883 163.921C47.2921 182.358 68.8816 191.806 96.9569 192H97.0695C122.03 191.827 139.624 185.292 154.118 170.811C173.081 151.866 172.51 128.119 166.26 113.541C161.776 103.087 153.227 94.5962 141.537 88.9883ZM98.4405 129.507C88.0005 130.095 77.1544 125.409 76.6196 115.372C76.2232 107.93 81.9158 99.626 99.0812 98.6368C101.047 98.5234 102.976 98.468 104.871 98.468C111.106 98.468 116.939 99.0737 122.242 100.233C120.264 124.935 108.662 128.946 98.4405 129.507Z"
    })
  }));
};

ThreadsIcon.defaultProps = {
  'aria-label': "Threads",
  viewBox: "0 0 192 192",
  xmlns: "http://www.w3.org/2000/svg"
};

var PinterestIcon = function PinterestIcon(props) {
  return /*#__PURE__*/_jsxs("svg", _objectSpread(_objectSpread({}, props), {}, {
    children: [/*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M8.8779 9.85385C8.29729 10.9183 8.27861 12.3212 8.89442 13.5528C9.1414 14.0468 8.94118 14.6474 8.4472 14.8944C7.95322 15.1414 7.35255 14.9412 7.10556 14.4472C6.22139 12.6788 6.20272 10.5817 7.12212 8.89615C8.06434 7.16875 9.92096 6 12.5 6C14.457 6 15.9423 6.88195 16.8692 8.16961C17.7746 9.42758 18.1239 11.0338 17.9538 12.5192C17.7836 14.0056 17.0762 15.4847 15.7299 16.3746C14.5809 17.134 13.1012 17.3769 11.3753 16.9852L10.4635 20.2676C10.3157 20.7998 9.76448 21.1113 9.23235 20.9635C8.70021 20.8157 8.38866 20.2645 8.53648 19.7324L9.71581 15.4868C9.71753 15.4804 9.71931 15.4739 9.72117 15.4675L11.0365 10.7324C11.1843 10.2002 11.7355 9.88867 12.2677 10.0365C12.7998 10.1843 13.1113 10.7355 12.9635 11.2676L11.9112 15.056C13.1622 15.3211 14.0396 15.0944 14.627 14.7061C15.37 14.215 15.8472 13.3358 15.9668 12.2917C16.0864 11.2467 15.8305 10.1502 15.2459 9.33801C14.6827 8.55555 13.7931 8 12.5 8C10.5791 8 9.43569 8.83125 8.8779 9.85385Z",
      fill: "#12131A"
    }), /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20ZM12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z",
      fill: "#12131A"
    })]
  }));
};

PinterestIcon.defaultProps = {
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};

var LinkIcon = function LinkIcon(props) {
  return /*#__PURE__*/_jsxs("svg", _objectSpread(_objectSpread({}, props), {}, {
    children: [/*#__PURE__*/_jsx("path", {
      d: "M13.7031 1.66693C12.4766 1.65619 11.296 2.13108 10.4155 2.98748L10.4069 2.99595L9.74681 3.65676C9.42156 3.98238 9.4219 4.51002 9.74748 4.83527C10.0731 5.16052 10.6008 5.16022 10.9261 4.83459L11.5816 4.1783C12.1481 3.62934 12.9046 3.32668 13.6885 3.33353C14.4743 3.34041 15.2272 3.65778 15.7846 4.21913C16.3423 4.78068 16.6596 5.54151 16.6665 6.33808C16.6733 7.13237 16.371 7.89659 15.826 8.46733L13.5288 10.7807C13.224 11.0878 12.8575 11.3248 12.4544 11.4763C12.0513 11.6277 11.6208 11.69 11.192 11.659C10.7632 11.6281 10.3457 11.5047 9.96798 11.2968C9.59023 11.089 9.26073 10.8015 9.00223 10.4535C8.72781 10.084 8.20581 10.007 7.83635 10.2814C7.46689 10.5558 7.38985 11.0778 7.6643 11.4473C8.065 11.9868 8.57656 12.4336 9.16456 12.7571C9.75265 13.0806 10.4031 13.2732 11.0721 13.3214C11.7411 13.3697 12.4124 13.2724 13.0405 13.0365C13.6685 12.8006 14.2384 12.4315 14.7116 11.9548L17.014 9.63633L17.0241 9.62592C17.8742 8.73958 18.3437 7.55358 18.3331 6.3237C18.3225 5.09381 17.8326 3.91618 16.9672 3.04474C16.1017 2.17312 14.9296 1.67766 13.7031 1.66693Z",
      fill: "#3A3D4D"
    }), /*#__PURE__*/_jsx("path", {
      d: "M8.92779 6.67878C8.25883 6.63054 7.58751 6.72775 6.95943 6.96368C6.33142 7.19959 5.76148 7.56868 5.28827 8.04534L2.98588 10.3638L2.97577 10.3742C2.12563 11.2606 1.65619 12.4466 1.6668 13.6765C1.67742 14.9063 2.16726 16.084 3.03263 16.9554C3.89819 17.8271 5.07029 18.3225 6.29682 18.3332C7.52335 18.344 8.70388 17.8691 9.58446 17.0127L9.59471 17.0025L10.251 16.3417C10.5752 16.0151 10.5734 15.4875 10.2468 15.1632C9.92021 14.8389 9.39263 14.8407 9.06829 15.1673L8.41754 15.8227C7.85107 16.3711 7.09498 16.6735 6.3114 16.6667C5.52558 16.6597 4.77269 16.3424 4.21524 15.781C3.65761 15.2195 3.34029 14.4587 3.33341 13.6621C3.32655 12.8677 3.62895 12.1036 4.17391 11.5328L6.4711 9.2195C6.77594 8.91241 7.14244 8.67533 7.54552 8.52391C7.94859 8.3725 8.37904 8.3102 8.80788 8.34116C9.23671 8.37208 9.65413 8.4955 10.0319 8.70333C10.4097 8.91116 10.7391 9.19866 10.9976 9.54666C11.2721 9.91616 11.794 9.99316 12.1635 9.71875C12.533 9.44433 12.61 8.92233 12.3356 8.55283C11.9349 8.0134 11.4233 7.5666 10.8353 7.24309C10.2473 6.91956 9.59671 6.72702 8.92779 6.67878Z",
      fill: "#3A3D4D"
    })]
  }));
};

LinkIcon.defaultProps = {
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
const LINKEDIN_URL = 'linkedin.com';
const INSTAGRAM_URL = 'instagram.com';
const X_URL = 'x.com';
const TWITTER_URL = 'twitter.com';
const TREADS_URL = 'threads.net';
const PINTEREST_URL = 'pinterest.com';
const SOCIAL_URLS = [LINKEDIN_URL, INSTAGRAM_URL, X_URL, TWITTER_URL, TREADS_URL, PINTEREST_URL];

const SocialLinks = _ref => {
  let {
    urls = [],
    className = ''
  } = _ref;
  const linkedInProfile = useMemo(() => getSocialLink(urls, LINKEDIN_URL), [urls]);
  const instagramProfile = useMemo(() => getSocialLink(urls, INSTAGRAM_URL), [urls]);
  const xProfile = useMemo(() => getSocialLink(urls, X_URL) || getSocialLink(urls, TWITTER_URL), [urls]);
  const threadsProfile = useMemo(() => getSocialLink(urls, TREADS_URL), [urls]);
  const pinterestProfile = useMemo(() => getSocialLink(urls, PINTEREST_URL), [urls]);
  const otherLink = useMemo(() => getPersonalLink(urls, SOCIAL_URLS), [urls]);
  return /*#__PURE__*/_jsxs("ul", {
    className: clsx(styles.socials, className),
    children: [linkedInProfile ? /*#__PURE__*/_jsx("li", {
      className: styles.socials__item,
      children: /*#__PURE__*/_jsx("a", {
        className: styles.link,
        href: linkedInProfile,
        target: "_blank",
        rel: "nofollow noopener noreferrer",
        children: /*#__PURE__*/_jsx(LinkedInIcon, {})
      })
    }) : /*#__PURE__*/_jsx(_Fragment, {}), xProfile ? /*#__PURE__*/_jsx("li", {
      className: clsx(styles.socials__item, styles['-twitter']),
      children: /*#__PURE__*/_jsx("a", {
        className: styles.link,
        href: xProfile,
        target: "_blank",
        rel: "nofollow noopener noreferrer",
        children: /*#__PURE__*/_jsx(XIcon, {})
      })
    }) : /*#__PURE__*/_jsx(_Fragment, {}), instagramProfile ? /*#__PURE__*/_jsx("li", {
      className: styles.socials__item,
      children: /*#__PURE__*/_jsx("a", {
        className: styles.link,
        href: instagramProfile,
        target: "_blank",
        rel: "nofollow noopener noreferrer",
        children: /*#__PURE__*/_jsx(InstagramIcon, {})
      })
    }) : /*#__PURE__*/_jsx(_Fragment, {}), threadsProfile ? /*#__PURE__*/_jsx("li", {
      className: styles.socials__item,
      children: /*#__PURE__*/_jsx("a", {
        className: styles.link,
        href: threadsProfile,
        target: "_blank",
        rel: "nofollow noopener noreferrer",
        children: /*#__PURE__*/_jsx(ThreadsIcon, {})
      })
    }) : /*#__PURE__*/_jsx(_Fragment, {}), pinterestProfile ? /*#__PURE__*/_jsx("li", {
      className: styles.socials__item,
      children: /*#__PURE__*/_jsx("a", {
        className: styles.link,
        href: pinterestProfile,
        target: "_blank",
        rel: "nofollow noopener noreferrer",
        children: /*#__PURE__*/_jsx(PinterestIcon, {})
      })
    }) : /*#__PURE__*/_jsx(_Fragment, {}), otherLink ? /*#__PURE__*/_jsx("li", {
      className: styles.socials__item,
      children: /*#__PURE__*/_jsx("a", {
        className: styles.link,
        href: otherLink,
        target: "_blank",
        rel: "nofollow noopener noreferrer",
        children: /*#__PURE__*/_jsx(LinkIcon, {})
      })
    }) : /*#__PURE__*/_jsx(_Fragment, {})]
  });
};

export default SocialLinks; // Determine if a list of urls contain a specific hostname

function getSocialLink(urls, target) {
  return urls.find(url => getHostname(url) === target) || '';
} // Determine if a list of urls contain a specific hostname


function getPersonalLink(urls, socialLinks) {
  return urls.find(url => !socialLinks.includes(getHostname(url))) || '';
}